import { useState } from "react";
import { useEffect } from "react";
import { getName, getPolicyType } from "../js/formatting";
import { useContext } from "react";
import { AgentData } from "context/Agent/DataProvider";
export const useClaimsMapper = () => {
  const [claims, setClaims] = useState([]);
  const { agentPolicies, agentClaims } = useContext(AgentData);

  useEffect(() => {
    let claimList = [];
    if (agentClaims?.length > 0) {
      agentClaims.forEach((selectedClaim) => {
        let policy = agentPolicies.find(
          (x) => x.contractID === selectedClaim.contractID
        );
        let party = policy?.parties?.find(
          (x) => x.person?.type?.toLowerCase() === "primary owner"
        );
        claimList.push({
          oldPolicy: selectedClaim?.oldPolicy,
          id: selectedClaim?.deathClaimNumber,
          title: `ID: ${selectedClaim?.deathClaimNumber}`,
          deathClaimNumber: selectedClaim.deathClaimNumber,
          banner:
            policy?.paymentStatus?.toLowerCase() === "approved"
              ? "good"
              : policy?.paymentStatus?.toLowerCase() === "declined"
              ? "problem"
              : "risk",
          badgeStatus:
            policy?.paymentStatus?.toLowerCase() === "approved"
              ? "good"
              : policy?.paymentStatus?.toLowerCase() === "declined"
              ? "problem"
              : "risk",
          status:
            policy?.paymentStatus?.toLowerCase() === "approved"
              ? "good"
              : policy?.paymentStatus?.toLowerCase() === "declined"
              ? "problem"
              : "risk",
          statusText: selectedClaim?.claimStatusDescription,
          badgeSrText: "Claim",
          badgeText: selectedClaim?.deathClaimStatus,
          policyNumber: selectedClaim?.contractID,
          contractID: selectedClaim?.contractID,
          owner:
            party?.person?.firstName && party?.person?.lastName
              ? `${policy ? `${getPolicyType(policy)} - ` : ""}${getName(
                  party?.person
                )}`
              : "",
          firstName: party?.person?.firstName,
          lastName: party?.person?.lastName,
          fullName: getName(party?.person),
          type: selectedClaim?.claimType,
          claimType: selectedClaim?.claimType,
          dateSubmitted: "",
          dateOfNotification: "",
          claimStatus: selectedClaim?.deathClaimStatus,
          deathClaimStatus: selectedClaim?.deathClaimStatus,
          step: 2,
          documents: [
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "First Notice Of Loss",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "Claimant Form",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "risk",
              badgeSrText: "Document",
              badgeText: "",
              name: "Claimant Form",
              action: "Update",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "Another Required Form",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "problem",
              badgeSrText: "Document",
              badgeText: "",
              name: "Another Required Form",
              action: "Update",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
          ],
        });
      });
    }
    setClaims(claimList);
  }, [agentPolicies]);

  return {
    claims: claims,
  };
};
